module.exports = __webpack_public_path__ + "images/instructor-shashank-kalanithi-mobile.webp";